import styled from 'styled-components';

const Post = styled.article`
  margin: 0px auto;
  max-width: 800px;
  width: 100%;
  div {
    margin: 32px 0;
  }
`;

export {Post}
